// @flow
import React from "react";
import Paper from "elevate-ui/Paper";
import classNames from "classnames";
import { Formik, Form, FastField } from "formik";
import Effect from "../common/FormikEffect";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Input from "elevate-ui/Input";
import Button from "elevate-ui/Button";
import { withSellerLeadContext } from "../common/SellerLeadContext";
import { withGlobalContext } from "../common/GlobalContext";

type $Props = {
  classes: Object,
  pageData: Object,
  handlePage1: Function,
  maybeAddressSearch: Function,
  renderAddresses: Function,
  renderLoading: Function,
  toggleAddressChosen: Function,
  city: string,
  state: string,
  buttonColor: string,
  address: Object,
  invalidAddress: boolean,
};

type State = {
  disabled: boolean,
};

class SellerPage1 extends React.Component<$Props, State> {
  props: $Props;
  state = {
    disabled: false,
  };

  render() {
    const {
      classes,
      renderAddresses,
      city,
      renderLoading,
      maybeAddressSearch,
      address,
      handlePage1,
      toggleAddressChosen,
      invalidAddress,
    } = this.props;

    return (
      <div className={classNames(classes.boxWrapper)}>
        <div className={classes.boxPage1}>
          <Typography
            type="title"
            className={classNames(classes.titlePage1)} //boxText, classes.title
          >
            What's Your {city} Area Home Really Worth?
          </Typography>
          <Paper withPadding={false} className={classes.resetPaperColors}>
            <Formik
              enableReinitialize={true}
              initialValues={{
                address: address.label || "",
              }}
              render={({ values }) => (
                <Form className={classes.formPadding} autoComplete="off">
                  <Effect
                    onChange={(current, next) =>
                      maybeAddressSearch(current, next)
                    }
                  />
                  <div className={classes.formFields}>
                    <div
                      className={classNames(
                        classes.formField,
                        classes.formFieldPage1
                      )}
                    >
                      <FastField
                        id="address"
                        name="address"
                        placeholder={`Enter Your Address`}
                        component={Input}
                        className={classes.inputField}
                        onKeyDown={toggleAddressChosen}
                      />
                      <div className={classes.dropdownWrapper}>
                        {renderLoading()}
                        {renderAddresses()}
                      </div>
                      {invalidAddress && (
                        <Button
                          color={this.props.buttonColor}
                          className={classNames(
                            classes.button,
                            classes.invalidAddressButton
                          )}
                          innerClassName={classNames(
                            classes.buttonInner,
                            classes.invalidAddressInnerButton
                          )}
                        >
                          Please choose an address from the dropdown
                        </Button>
                      )}
                    </div>
                    <div className={classes.buttonField}>
                      <Button
                        type="button"
                        disabled={this.state.disabled}
                        color={this.props.buttonColor}
                        className={classes.button}
                        innerClassName={classes.buttonInner}
                        onClick={() => {
                          handlePage1(values);
                          this.setState({ disabled: true });
                        }}
                      >
                        Get My Value Now >>
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            />
          </Paper>
          <Typography
            type="body"
            className={classNames(classes.subTitlePage1)} //classes.boxText, classes.boxText2
          >
            Get the most accurate valuation using the local {city} area MLS
            data.
          </Typography>
        </div>
      </div>
    );
  }
}

const styles = (theme) => {
  const tabletL = 992;
  const tabletP = 768;
  const mobile = 480;

  return {
    boxWrapper: {
      width: "100%",
      [`@media (min-width: ${tabletP}px)`]: {
        width: "85%",
        marginTop: "calc(10% - 20px)",
        marginBottom: "calc(10%)",
      },
      [`@media (min-width: ${tabletL}px)`]: {
        width: "743px",
        height: "203px",
        marginTop: "112px",
        marginBottom: "calc(10%)",
      },
      display: "flex",
      zIndex: "1",
      position: "relative",
      flexFlow: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    boxPage1: {
      width: "100%",
      borderRadius: `26px`,
      border: `6px solid ${theme.colors.white}`,
      backgroundColor: "#246684", //#276989",
      opacity: "0.95",
      padding: `${theme.spacing.unit}px`,
      [`@media (min-width: ${mobile}px)`]: {
        padding: `${theme.spacing.unit * 1.5}px`,
      },
      textAlign: "center",
      boxShadow: theme.shadows[4],
    },
    resetPaperColors: { border: "none", background: "none" },
    titlePage1: {
      color: theme.colors.white,
      fontSize: "30px",
      fontWeight: "500 !important",
    },
    subTitlePage1: {
      color: theme.colors.white,
      fontSize: "20px",
    },
    boxText: {
      color: "white",
      margin: "12px auto",
      lineHeight: "1.2",
      fontWeight: "normal",
    },
    boxText2: {
      fontSize: "22px",
      fontWeight: "600",
    },
    formPadding: { paddingBottom: "4px" },
    formFields: { display: "flex", flexWrap: "wrap" },
    formField: { flexGrow: "1", maxWidth: "100%" },
    formFieldPage1: {
      "& > [class*='Scaffold-root']": {
        paddingTop: "1px",
      },
    },
    buttonField: {
      margin: "8px auto 16px 4px",
      width: "100%",
      [`@media (min-width: ${tabletL}px)`]: {
        width: "250px",
      },
      "& button": {
        background: `linear-gradient(#f7941d,#d75305)`,
        borderRadius: "0",
        border: "1px solid #333333",
        boxShadow: "inset 0px 1px 0px #ffbb6a, inset 0 -1px 2px #a33f03",
        textShadow: "1px 1px #521601",
      },
    },
    button: {
      height: "48px",
      width: "100%",
      [`@media (min-width: ${tabletL}px)`]: {
        width: "auto",
      },
    },
    inputField: {
      borderRadius: "0",
      height: "46px",
      "&::placeholder": {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: `${theme.colors.gray[600]} !important`,
      },
      "&:-ms-input-placeholder": {
        /* Internet Explorer 10-11 */
        color: `${theme.colors.gray[600]} !important`,
      },
      "&::-ms-input-placeholder": {
        /* Microsoft Edge */
        color: `${theme.colors.gray[600]} !important`,
      },
    },
    buttonInner: {
      color: theme.colors.white,
      fontSize: "20px",
      textShadow: "1px 1px #521601",
      fontWeight: "700",
      whiteSpace: "nowrap",
    },
    dropdownWrapper: {
      position: "absolute",
      background: "white",
      marginTop: "-20px",
      borderRadius: "6px",
      boxShadow: "0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12)",
      zIndex: "2",
    },
    invalidAddressButton: {
      height: "auto",
    },
    invalidAddressInnerButton: {
      fontSize: "14px",
    },
  };
};

export default withGlobalContext(
  withSellerLeadContext(withStyles(styles)(SellerPage1))
);
